import "jquery";
import _ from "lodash";
import "./terms.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const page_title = "Términos y Condiciones";

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle(page_title, page_template_header_title);

/**** main content start ****/
let news_container = document.createElement("div");
page_template_content.appendChild(news_container);
showNews(news_container);

/**** main content end ****/

//page_footer
page_footer.render(base_url, id_season);

//hide loader at the end, always at the bottom of this index file
$(window).on("load", function () {
  page_template.hideLoader();
});

async function showNews(container) {
  await getNews().then((response) => {
    let title = document.createElement("h1");
    let content = document.createElement("div");

    title.innerText = response.item.title;
    content.innerHTML = response.item.text;

    container.appendChild(title);
    container.appendChild(content);
  });
}

//********* page functions start ******/
async function getNews() {
  //Prepare the request data.
  var ajax_data = {
    id: 11
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/cms/entries/single",
    data: ajax_data
  });
}
